import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/shared/auth/auth.service';
import { SharedService } from 'app/shared/services/shared.service';
import { ToastrService } from 'ngx-toastr';
import { IPayment } from '../../models/payment';
import { PaymentService } from '../../services/payments.service';
import { DialogEditPaymentComponent } from '../edit/edit-payment-dialog';
import { DialogMarkPaidComponent } from '../edit/mark-paid';

@Component({
  selector: 'app-manage-payments',
  templateUrl: './manage-payments.component.html',
  styleUrls: ['./manage-payments.component.scss']
})

export class ManagePaymentComponent implements OnInit {
  //@Input() licenseSubTypeId = "";
  @Input() entityId: string = "";
  @Input() entityType: string = "";
  @Input() classification: string = "";
  @Input() allowMultiplePayments: boolean = false;
  @Input() allowDelete: boolean = true;
  @Input() editingPayment: boolean = false;
  @Input() showCleared: boolean = true;
  @Input() sku: string | null = null;
  @Output() notifyParent: EventEmitter<IPayment[]> = new EventEmitter<IPayment[]>();

  public updateParent: boolean = true;
  public processing: boolean = false;
  public paymentsSource = new MatTableDataSource<IPayment>();
  public payments: IPayment[] = [];
  public paymentColumns: string[] = ['type', 'status', 'paymentCleared', 'amount', 'paymentMethod', 'sku', 'comment', 'localReferenceId', 'actions'];

  constructor(public sharedService: SharedService,
    public authService: AuthService,
    public paymentService: PaymentService,
    private dialog: MatDialog,
    private toastr: ToastrService) { }

  ngOnInit() {
    //this.populatePaymentOptions();
    this.loadPayments();
  }

  loadPayments(): void {
    this.processing = true;
    this.paymentService.getPaymentsByEntity(this.entityId, this.entityType).subscribe({
      next: response => {
        this.payments = response;
        if (!this.showCleared) {
          this.payments = this.payments.filter(payment => !payment.paymentCleared);
        }
        if (this.sku) {
          this.payments = this.payments.filter(payment => payment.sku === this.sku);
        }
        this.paymentsSource = new MatTableDataSource<IPayment>(this.payments);
      },
      error: e => console.log('error getting payments', e),
      complete: () => {
        if (this.updateParent) {
          this.notifyParent.emit(this.payments);
          this.updateParent = false;
          this.processing = false;
        }
      }
    });
  }

  // populatePaymentOptions(): void {
  //   if (this.licenseSubTypeId && this.paymentService.paymentOptions.length === 0) {
  //     this.paymentService.getPaymentTypes(this.licenseSubTypeId).subscribe({
  //       next: (paymentOptions) => {
  //         this.paymentService.paymentOptions = paymentOptions;
  //       },
  //       error: (error) => {
  //         console.error('Error loading payment options:', error);
  //       }
  //     });
  //   }
  // }

  markAsCleared(payment: IPayment) {
    const dialogRef = this.dialog.open(DialogMarkPaidComponent, {
      data: payment,
      minWidth: '300px',
      maxWidth: !this.sharedService.mobile ? '800px' : '300px',
      maxHeight: '500px',

    });
    dialogRef.afterClosed().subscribe((response) => {
      if (!this.sharedService.isCancelled(response)) {
        this.updateParent = true;
        this.loadPayments();
      }
    });
  }

  deletePayment(paymentId: number, type: string) {
    this.sharedService.openConfirm(
      "Are you sure you want to delete this payment? Continue?"
    );
    this.sharedService.confirmed().subscribe(
      confirmed => {
        if (confirmed) {
          this.processing = true;
          this.paymentService.deletePayment(paymentId, type).subscribe(
            () => {
              this.updateParent = true;
              this.loadPayments();
              this.processing = false;
              this.toastr.success("Payment Removed");
            },
            error => console.log('error', error)
          );
        }
      }
    );
  }

  addNewPayment() {
    let payment: IPayment = {
      id: 0,
      localReferenceId: '',
      paymentGuid: '',
      paid: false,
      status: '',
      sku: '',
      type: this.entityType,
      orderNumber: '',
      orderRecordId: '',
      billingName: '',
      billingAddress: '',
      orderTimePlaced: '',
      quantity: 1,
      amount: "0.00",
      comment: '',
      createdBy: '',
      dastUpdatedBy: '',
      dateCreated: '',
      dateLastUpdated: '',
      entityId: this.entityId,
      entityType: this.entityType,
      paymentCleared: '',
      paymentMethod: '',
    }

    const dialogRef = this.dialog.open(DialogEditPaymentComponent, {
      data: {
        payment: payment,
        licenseType: this.entityType
      },
      minWidth: !this.sharedService.mobile ? '700px' : '300px',
      maxWidth: !this.sharedService.mobile ? '800px' : '300px',
      maxHeight: !this.sharedService.mobile ? '1000px' : '500px',

    });

    dialogRef.afterClosed().subscribe((response) => {
      if (!this.sharedService.isCancelled(response)) {
        this.updateParent = true;
        this.loadPayments();
      }
    });
  }

  editPayment(payment: IPayment) {
    const dialogRef = this.dialog.open(DialogEditPaymentComponent, {
      data: {
        payment: payment,
        licenseType: this.entityType
      },
      minWidth: !this.sharedService.mobile ? '700px' : '300px',
      maxWidth: !this.sharedService.mobile ? '800px' : '300px',
      maxHeight: !this.sharedService.mobile ? '1000px' : '500px',

    });
    dialogRef.afterClosed().subscribe((response) => {
      if (!this.sharedService.isCancelled(response)) {
        this.updateParent = true;
        this.loadPayments();
      }
    });
  }
}
